import { useState, useEffect, useMemo } from 'react';

export default () => {
  const [audioInputDevices, setMicrophones] = useState([]);
  const [audioOutputDevices, setSpeakers] = useState([]);
  const [videoInputDevices, setCameras] = useState([]);
  const [environmentalVideoInputDevices, setBackCameras] = useState([]);
  const [hasAudioInputDevices, setHasAudioInputDevices] = useState(false);
  const [hasVideoInputDevices, setHasVideoInputDevices] = useState(false);

  const [microphonePermissions, setMicrophonePermissions] = useState(false);
  const [cameraPermissions, setCameraPermissions] = useState(false);
  useEffect(() => {
    if (navigator?.permissions?.query) {
      navigator.permissions.query({ name: 'microphone' }).then((permissionStatus) => {
        setMicrophonePermissions(permissionStatus.state);
        // eslint-disable-next-line no-param-reassign, func-names
        permissionStatus.onchange = function () {
          setMicrophonePermissions(this.state);
        };
      });
      navigator.permissions.query({ name: 'camera' }).then((permissionStatus) => {
        setCameraPermissions(permissionStatus.state);
        // eslint-disable-next-line no-param-reassign, func-names
        permissionStatus.onchange = function () {
          setCameraPermissions(this.state);
        };
      });
    }
  }, []);

  useEffect(() => {
    const updateDeviceInfo = async () => {
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        // eslint-disable-next-line no-console
        console.log('enumerateDevices() not supported.');
        return;
      }
      const devices = await navigator.mediaDevices.enumerateDevices();
      const microphonesList = devices.filter((d) => d.kind === 'audioinput').map((d) => ({ value: d.deviceId, label: d.label }));
      const speakersList = devices.filter((d) => d.kind === 'audiooutput').map((d) => ({ value: d.deviceId, label: d.label }));
      const camerasList = devices.filter((d) => d.kind === 'videoinput' && d.label.toLowerCase().indexOf('back') === -1).map((d) => ({ value: d.deviceId, label: d.label }));
      const backCamerasList = devices.filter((d) => d.kind === 'videoinput' && d.label.toLowerCase().indexOf('back') >= 0).map((d) => ({ value: d.deviceId, label: d.label }));
      setHasAudioInputDevices(microphonesList.length > 0);
      setHasVideoInputDevices(camerasList.length > 0);
      setMicrophones(microphonesList);
      setSpeakers(speakersList);
      setCameras(camerasList);
      setBackCameras(backCamerasList);
    };
    updateDeviceInfo();
    if (navigator.mediaDevices.ondevicechange === null) {
      navigator.mediaDevices.ondevicechange = () => {
        updateDeviceInfo();
      };
      return () => {
        navigator.mediaDevices.ondevicechange = null;
      };
    }
    if (navigator.mediaDevices && navigator.mediaDevices.addEventListener) {
      navigator.mediaDevices.addEventListener('devicechange', updateDeviceInfo);
      return () => {
        navigator.mediaDevices.removeEventListener('devicechange', updateDeviceInfo);
      };
    }
  }, [microphonePermissions, cameraPermissions]);

  const devicesAvailability = useMemo(
    () => ({
      microphoneEnabled: audioInputDevices.some((m) => m.label),
      cameraEnabled: videoInputDevices.some((m) => m.label),
      speakerEnabled: audioOutputDevices.some((m) => m.label),
      isCameraPermissionDenied: !videoInputDevices.some((m) => m.label),
      isMicrophonePermissionDenied: !audioInputDevices.some((m) => m.label),
    }),
    [audioInputDevices, audioOutputDevices, videoInputDevices],
  );

  return {
    audioInputDevices,
    audioOutputDevices,
    videoInputDevices,
    environmentalVideoInputDevices,
    hasAudioInputDevices,
    hasVideoInputDevices,
    devicesAvailability,
  };
};
